import { TFunction } from 'i18next';
import React from 'react';

import { ModalConfirmation } from '../../components/ModalConfirmation';

interface DateRangeChangeModalProps {
  isOpen: boolean;
  onSubmit: () => void;
  onClose: () => void;
  t: TFunction;
}

export type DateRangeChangeModalStatus = 'ready' | 'open' | 'obsolete';

export const DateRangeChangeModal: React.FC<DateRangeChangeModalProps> = ({ isOpen, onSubmit, onClose, t }) =>
  isOpen ? (
    <ModalConfirmation
      headerText={t('layout.warning')}
      bodyText={t('schedule.modal.dateRangeChangeBody')}
      submitText={t('layout.action.proceed')}
      closeText={t('layout.action.cancel')}
      onSubmit={onSubmit}
      show
      onClose={onClose}
    />
  ) : null;
